<template>
  <ims-modal
    :title="$store.state.interact.modals.newLeague.title"
    :canClose="true"
    :show="$store.state.interact.modals.newLeague.show"
    :onClose="close"
  >
    <main class="p-4">
      <h1>Welcome Commissioner!</h1>
      <p>
        Private Leagues are great to invite your friends and colleagues to
        compete against each other during the season.
      </p>
      <p>
        Private Leagues use the same scoring systems as the public leagues and
        overall standings. Let’s get started!
      </p>

      <ims-input
        type="text"
        :maxlength="30"
        placeholder="League Name"
        v-model="name"
        help="4 characters minimum"
      ></ims-input>

      <ims-button
        type="solid"
        :disabled="!canSave"
        @click="createLeague"
        color="primary"
        size="lg"
        class="btn-block my-3"
      >Create League</ims-button>
    </main>
  </ims-modal>
</template>

<script>
import League from '../../classes/league';
export default {
  data() {
    return {
      name: '',
      password: ''
    };
  },
  methods: {
    close() {
      this.$store.commit('modals/newLeague', null);
    },
    async createLeague() {
      // Create a League
      let league = new League({
        name: this.name,
        isPrivate: true,
        isAdmin: true,
        isFirestone: this.$store.state.brand.name == 'Firestone',
        brandId: this.$store.state.brand.id
      });
      // Show Loading
      let closeLoader = await this.$store.dispatch(
        'loader/start',
        'Creating League...'
      );
      // Save via Service
      let response = await this.$User.service.createLeague(league);
      // Close Loading
      closeLoader();
      // Close Window
      this.close();

      // Redirect to Admin
      if (response.id) {
        this.name = '';
        await this.$store.dispatch('leagues/mine/load');
        this.$router.push(`leagues/${response.id}/admin`);
      }
      // Dispatch Notifications
      this.$store.dispatch('interact/toast', { title: 'League Created' });
    }
  },
  mounted() {},
  computed: {
    canSave() {
      return this.name.length > 3;
    }
  }
};
</script> 

<style lang="scss"></style>
